import { BaseEntity, JsonApiProperty, JsonApiResource } from '../jsonapi-provider';
import { randomUUID } from '../utils/utils';

interface ResultType {
  recordCount: number;
  httpStatus: number;
  completedOn: string;
  url: string;
  message?: string;
}

@JsonApiResource({ type: 'tableExport' })
export default class TableExport extends BaseEntity {
  resultType: 'CSV' | 'JSON' | 'PDF' | 'PDF_AGG' | 'CUSTOM_CSV' | 'CUSTOM_XLSX' = 'CSV';
  @JsonApiProperty({ resolver: Number }) asyncAfterSeconds = 30;
  query = '';
  queryType: 'JSONAPI_V1_0' = 'JSONAPI_V1_0';
  status = 'QUEUED';
  @JsonApiProperty({ type: 'object' }) result: ResultType | null = null;

  constructor(
    id: TableExport['id'] = randomUUID(),
    query: TableExport['query'] = '/',
    resultType: TableExport['resultType'] = 'CSV',
    asyncAfterSeconds: TableExport['asyncAfterSeconds'] = 30,
    queryType: TableExport['queryType'] = 'JSONAPI_V1_0',
    status: TableExport['status'] = 'QUEUED',
    result: TableExport['result'] = null
  ) {
    super();
    this.id = id;
    this.query = query;
    this.resultType = resultType;
    this.asyncAfterSeconds = asyncAfterSeconds;
    this.queryType = queryType;
    this.status = status;
    this.result = result;
  }
}
